import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import pdf from "../../../../assets/img/pdf.png";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const SMS_PreviousPapers = () => {
  const [data, setData] = useState([]);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(getAPIPath(currentDomain)?.previousPapers, setData);
  }, [currentDomain]);

  return (
    <React.Fragment>
      <Helmet>
        <title>Previous Papers | SMS | JNTU Anantapur</title>
        <meta
          name="description"
          content="Previous examination papers for MBA programs at School of Management Studies, JNTUA"
        />
        <meta
          name="keywords"
          content="Previous Papers, Question Papers, SMS, MBA, JNTUA, Examinations"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .section-header {
                        background: linear-gradient(135deg, #ff6600, #ff8533);
                        color: white;
                        padding: 15px 20px;
                        border-radius: 8px 8px 0 0;
                        font-weight: bold;
                        font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .paper-section {
                        margin-bottom: 30px;
                        border: 1px solid #ddd;
                        border-radius: 8px;
                        overflow: hidden;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    }
                    
                    .paper-links {
                        padding: 0;
                    }
                    
                    .paper-link-item {
                        padding: 15px 20px;
                        border-bottom: 1px solid #f0f0f0;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        transition: background-color 0.3s ease;
                    }
                    
                    .paper-link-item:hover {
                        background-color: #f8f9fa;
                    }
                    
                    .paper-link-item:last-child {
                        border-bottom: none;
                    }
                    
                    .link-label {
                        font-weight: 500;
                        color: #333;
                        flex: 1;
                    }
                    
                    .pdf-icon {
                        width: 24px;
                        height: 24px;
                        margin-left: 10px;
                        opacity: 0.7;
                    }
                    
                    .drive-folder-box {
                        background: linear-gradient(135deg, #4285f4, #5a9bf7);
                        color: white;
                        padding: 25px;
                        border-radius: 12px;
                        margin-bottom: 30px;
                        box-shadow: 0 4px 8px rgba(66, 133, 244, 0.3);
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    
                    .drive-folder-text {
                        font-size: calc(${fontSize}px + 2px);
                        font-weight: 600;
                        margin: 0;
                    }
                    
                    .drive-folder-btn {
                        background: white;
                        color: #4285f4;
                        padding: 12px 30px;
                        border-radius: 25px;
                        text-decoration: none;
                        font-weight: bold;
                        transition: all 0.3s ease;
                        display: inline-flex;
                        align-items: center;
                        gap: 8px;
                    }
                    
                    .drive-folder-btn:hover {
                        background: #f1f3f4;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
                        color: #4285f4;
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Previous Papers"
          pageName="Previous Papers"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title">Previous Examination Papers</h3>
                    
                    {/* Google Drive Folder Link */}
                    {data?.data?.attributes?.driveFolder && (
                      <div className="drive-folder-box">
                        <div>
                          <i className="fab fa-google-drive" style={{ fontSize: "32px", marginRight: "15px" }}></i>
                          <span className="drive-folder-text">Access All Previous Papers on Google Drive</span>
                        </div>
                        <a
                          href={data.data.attributes.driveFolder}
                          target="_blank"
                          rel="noreferrer"
                          className="drive-folder-btn"
                        >
                          <i className="fas fa-external-link-alt"></i>
                          {data.data.attributes.driveLabel || "Click Here"}
                        </a>
                      </div>
                    )}
                    
                    {data?.data?.attributes?.sections?.length > 0 ? (
                      data.data.attributes.sections.map((section, sectionIndex) => (
                        <div key={section.id} className="paper-section">
                          <div className="section-header">
                            {section.title}
                          </div>
                          <div className="paper-links">
                            {section.links?.map((link, linkIndex) => (
                              <div key={link.id} className="paper-link-item">
                                <div className="link-label">
                                  <span className="me-3" style={{ color: "#ff6600", fontWeight: "bold" }}>
                                    {(linkIndex + 1).toString().padStart(2, "0")}.
                                  </span>
                                  {link.label}
                                </div>
                                <div className="d-flex align-items-center">
                                  {link.content?.data?.attributes?.url ? (
                                    <a
                                      href={
                                        imageBaseURL +
                                        link.content.data.attributes.url
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                      title={`Download ${link.label}`}
                                      className="d-flex align-items-center text-decoration-none"
                                    >
                                      <span style={{ color: "#ff6600", fontSize: "12px", marginRight: "8px" }}>
                                        Download PDF
                                      </span>
                                      <img
                                        alt="PDF"
                                        src={pdf}
                                        className="pdf-icon"
                                      />
                                    </a>
                                  ) : (
                                    <span 
                                      style={{ 
                                        color: "#999", 
                                        fontStyle: "italic",
                                        fontSize: "12px"
                                      }}
                                    >
                                      PDF Not Available
                                    </span>
                                  )}
                                </div>
                              </div>
                            ))}
                            {(!section.links || section.links.length === 0) && (
                              <div className="paper-link-item">
                                <span style={{ color: "#999", fontStyle: "italic" }}>
                                  No previous papers available for this section.
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center" style={{ padding: "60px 20px" }}>
                        <div style={{ color: "#666", fontSize: "16px" }}>
                          <i className="fas fa-file-alt" style={{ fontSize: "48px", marginBottom: "20px", color: "#ddd" }}></i>
                          <br />
                          No previous papers available at the moment.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SMS_PreviousPapers;